





































import Vue from 'vue'
import UiSelect, { SelectOption } from '../../UiSelect'
import UiFormField from '../UiFormField'
export default (Vue as typeof UiFormField).extend({
  name: 'UiFormSelect',
  components: {
    UiSelect
  },
  extends: UiFormField,
  computed: {
    options (): SelectOption[] {
      return Object.entries(this.field.properties?.options).map(([value, label]): SelectOption => ({
        label: label as (string | number),
        value: value as (string | number | boolean)
      }))
    },
    placeholder (): string {
      return this.field?.properties?.prependOptionLabel
    }
  }
})
